import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';
import '@effectivastudio/lit-components/components/icon/element.js';
import CardHeader from '../card_header/element.js';
import '../origin/element.js';
import style from './style.lit.css';

/**
 * @prop cardType - Card type icon (options: event, date, discussion, engagement, marketplace, news, organize, poll)
 * @prop url - Cards's destination url.
 * @prop ownerName - Card's owner name.
 * @prop ownerImage - Card's owner image.
 * @prop createdAt - Card's created date.
 *
 * @slot origin - For Origin component.
 * @slot title - For title.
 *
 * @cssprop --bg - Component background.
 * @cssprop --bg-hover - Component background on hover.
 * @cssprop --bg-active - Component background on clicked.
 * @cssprop --color - Component primary text color.
 * @cssprop --color-secondary - Component secondary text color.
 */

export default class CardV1 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    cardType: { type: String },
    url: { type: String },
    ownerName: { type: String },
    ownerImage: { type: String },
    createdAt: { type: Date },
  };

  /** @internal */
  get iconName() {
    return CardHeader.TYPE_ICON_NAMES[this.cardType];
  }

  content() {
    return html`
      <header>
        <ef-avatar
          name=${this.ownerName}
          picture=${this.ownerImage}
          rounded
          disableInitials>
        </ef-avatar>
        <div class="content">
          <h3>${this.ownerName}</h3>
          <div class="info">
            <ef-timeago .timestamp=${this.createdAt}> </ef-timeago>
            <slot name="origin"></slot>
          </div>
        </div>
        <ef-icon name=${this.iconName}></ef-icon>
      </header>
      <slot name="title"></slot>
    `;
  }

  renderContent() {
    return html` <div class="wrapper">${this.content()}</div> `;
  }

  renderUrlContent() {
    return html` <a class="wrapper" href=${this.url}> ${this.content()} </a> `;
  }

  render() {
    return html` ${this.url ? this.renderUrlContent() : this.renderContent()} `;
  }
}

customElements.get('xs-card-v1') || customElements.define('xs-card-v1', CardV1);
